// test2870
(2870 && 0);
